Object.defineProperty(exports, "__esModule", { value: true });
exports.FormRenderError = exports.JsonParseError = void 0;
class JsonParseError extends Error {
}
exports.JsonParseError = JsonParseError;
class FormRenderError extends Error {
    constructor(message) {
        super(`${message} Can not render form.`);
    }
}
exports.FormRenderError = FormRenderError;
//# sourceMappingURL=errors.js.map